unit SystemGeneralLedgerAccountsSetup;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, Vcl.Controls,
  WEBLib.ExtCtrls, WEBLib.DBCtrls, Data.DB, WEBLib.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, XData.Web.Client;

type
  TfrmGeneralLedgerAccounts = class(TForm)
    WebPanel1: TPanel;
    WebDBEdit1: TDBEdit;
    WebDBEdit2: TDBEdit;
    WebLabel1: TLabel;
    WebLabel2: TLabel;
    WebButton3: TButton;
    WebPanel2: TPanel;
    WebPanel3: TPanel;
    WebButton1: TButton;
    WebButton2: TButton;
    wcGLCodes: TXDataWebClient;
    wdsGLCodes: TXDataWebDataSet;
    wdsGLCodesGLCODE: TStringField;
    wdsGLCodesGLDESCRIPTION: TStringField;
    wdsGLCodesSUSPENDED: TBooleanField;
    wdsGLCodesbankaccount: TBooleanField;
    wdsGLCodesbankcard: TBooleanField;
    dsGLCodes: TDataSource;
    cbxSuspended: TCheckBox;
    cbxBankAccounts: TCheckBox;
    cbxCardPayment: TCheckBox;
    procedure WebFormShow(Sender: TObject);
    procedure WebButton1Click(Sender: TObject);
    procedure WebButton2Click(Sender: TObject);
    procedure wdsGLCodesAfterOpen(DataSet: TDataSet);
  private
    { Private declarations }
  public
    { Public declarations }
    iState : Integer;
    sGLCode : String;
  protected procedure LoadDFMValues; override; end;

var
  frmGeneralLedgerAccounts: TfrmGeneralLedgerAccounts;

implementation

{$R *.dfm}

uses
  stfmssystem.connection , share.system.classes , share.common,systemsettings;

procedure TfrmGeneralLedgerAccounts.wdsGLCodesAfterOpen(DataSet: TDataSet);
begin

      cbxSuspended.Checked := wdsGLCodes.FieldByName('Suspended').AsBoolean;

      cbxBankAccounts.Checked := wdsGLCodes.FieldByName('bankaccount').AsBoolean;

      cbxCardPayment.Checked := wdsGLCodes.FieldByName('bankcard').AsBoolean;

end;

procedure TfrmGeneralLedgerAccounts.WebButton1Click(Sender: TObject);
  procedure OnSuccess(Response : TXDataClientResponse);
    begin
      wdsGLCodes.Cancel;
      Close;
    end;
  procedure OnError(Error: TXDataClientError);
    begin
      ShowMessage(Error.ErrorMessage);
      Close;
    end;
begin

  wdsGLCodes.FieldByName('Suspended').AsBoolean := cbxSuspended.Checked;

  wdsGLCodes.FieldByName('bankaccount').AsBoolean := cbxBankAccounts.Checked;

  wdsGLCodes.FieldByName('bankcard').AsBoolean := cbxCardPayment.Checked;

  case iState of
    1:  Begin
          console.log(GetJsonFromDataSet(wdsGLCodes));
          wcGLCodes.RawInvoke('IstfmsSystemService.Put_GLAccounts_Insert',[GetJsonFromDataSet(wdsGLCodes)],@OnSuccess, @OnError);
        End;
    2:  Begin
          console.log(GetJsonFromDataSet(wdsGLCodes));
          wcGLCodes.RawInvoke('IstfmsSystemService.Put_GLAccounts_Edit',[GetJsonFromDataSet(wdsGLCodes),sGLCode],@OnSuccess, @OnError);
        end;
  end;
end;

procedure TfrmGeneralLedgerAccounts.WebButton2Click(Sender: TObject);
begin
  Close;
end;

procedure TfrmGeneralLedgerAccounts.WebFormShow(Sender: TObject);

  procedure OnResultGLCodes(Response : TXDataClientResponse);
    begin
      wdsGLCodes.Close;
      wdsGLCodes.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsGLCodes.Open;

      if iState = 2 then
        Begin
          wdsGLCodes.Edit;
        End;
    end;
begin
  //wcGLCodes.RawInvoke('IstfmsSystemService.Get_GLCodes_View',[0,'*'],@OnResultGLCodes);
  case iState of
    1 : Begin
          wdsGLCodes.Open;
          wdsGLCodes.Insert;
        End;
    2 : Begin
          wcGLCodes.RawInvoke('IstfmsSystemService.Get_GLCodes_View',[0,sGLCode],@OnResultGLCodes);
        End;
  end;

end;

procedure TfrmGeneralLedgerAccounts.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebDBEdit1 := TDBEdit.Create(Self);
  WebDBEdit2 := TDBEdit.Create(Self);
  WebButton3 := TButton.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  WebButton1 := TButton.Create(Self);
  WebButton2 := TButton.Create(Self);
  cbxSuspended := TCheckBox.Create(Self);
  cbxBankAccounts := TCheckBox.Create(Self);
  cbxCardPayment := TCheckBox.Create(Self);
  wcGLCodes := TXDataWebClient.Create(Self);
  wdsGLCodes := TXDataWebDataSet.Create(Self);
  wdsGLCodesGLCODE := TStringField.Create(Self);
  wdsGLCodesGLDESCRIPTION := TStringField.Create(Self);
  wdsGLCodesSUSPENDED := TBooleanField.Create(Self);
  wdsGLCodesbankaccount := TBooleanField.Create(Self);
  wdsGLCodesbankcard := TBooleanField.Create(Self);
  dsGLCodes := TDataSource.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebDBEdit1.BeforeLoadDFMValues;
  WebDBEdit2.BeforeLoadDFMValues;
  WebButton3.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  WebButton2.BeforeLoadDFMValues;
  cbxSuspended.BeforeLoadDFMValues;
  cbxBankAccounts.BeforeLoadDFMValues;
  cbxCardPayment.BeforeLoadDFMValues;
  wcGLCodes.BeforeLoadDFMValues;
  wdsGLCodes.BeforeLoadDFMValues;
  wdsGLCodesGLCODE.BeforeLoadDFMValues;
  wdsGLCodesGLDESCRIPTION.BeforeLoadDFMValues;
  wdsGLCodesSUSPENDED.BeforeLoadDFMValues;
  wdsGLCodesbankaccount.BeforeLoadDFMValues;
  wdsGLCodesbankcard.BeforeLoadDFMValues;
  dsGLCodes.BeforeLoadDFMValues;
  try
    Name := 'frmGeneralLedgerAccounts';
    Width := 640;
    Height := 382;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 640;
    WebPanel1.Height := 382;
    WebPanel1.Align := alClient;
    WebPanel1.TabOrder := 0;
    WebLabel1.SetParentComponent(WebPanel1);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 120;
    WebLabel1.Top := 112;
    WebLabel1.Width := 96;
    WebLabel1.Height := 15;
    WebLabel1.Caption := 'GL Account Code:';
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebLabel2.SetParentComponent(WebPanel1);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 88;
    WebLabel2.Top := 139;
    WebLabel2.Width := 128;
    WebLabel2.Height := 15;
    WebLabel2.Caption := 'GL Account Description:';
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebDBEdit1.SetParentComponent(WebPanel1);
    WebDBEdit1.Name := 'WebDBEdit1';
    WebDBEdit1.Left := 232;
    WebDBEdit1.Top := 108;
    WebDBEdit1.Width := 169;
    WebDBEdit1.Height := 22;
    WebDBEdit1.ChildOrder := 5;
    WebDBEdit1.HeightPercent := 100.000000000000000000;
    WebDBEdit1.WidthPercent := 100.000000000000000000;
    WebDBEdit1.DataField := 'GLCODE';
    WebDBEdit1.DataSource := dsGLCodes;
    WebDBEdit2.SetParentComponent(WebPanel1);
    WebDBEdit2.Name := 'WebDBEdit2';
    WebDBEdit2.Left := 232;
    WebDBEdit2.Top := 136;
    WebDBEdit2.Width := 281;
    WebDBEdit2.Height := 22;
    WebDBEdit2.ChildOrder := 6;
    WebDBEdit2.HeightPercent := 100.000000000000000000;
    WebDBEdit2.WidthPercent := 100.000000000000000000;
    WebDBEdit2.DataField := 'GLDESCRIPTION';
    WebDBEdit2.DataSource := dsGLCodes;
    WebButton3.SetParentComponent(WebPanel1);
    WebButton3.Name := 'WebButton3';
    WebButton3.Left := 407;
    WebButton3.Top := 107;
    WebButton3.Width := 25;
    WebButton3.Height := 25;
    WebButton3.Caption := '...';
    WebButton3.ChildOrder := 9;
    WebButton3.HeightPercent := 100.000000000000000000;
    WebButton3.WidthPercent := 100.000000000000000000;
    WebPanel2.SetParentComponent(WebPanel1);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 0;
    WebPanel2.Width := 640;
    WebPanel2.Height := 40;
    WebPanel2.Align := alTop;
    WebPanel2.Caption := 'General Ledger Accounts';
    WebPanel2.ChildOrder := 10;
    WebPanel2.Font.Charset := DEFAULT_CHARSET;
    WebPanel2.Font.Color := clWindowText;
    WebPanel2.Font.Height := -16;
    WebPanel2.Font.Name := 'Segoe UI';
    WebPanel2.Font.Style := [fsBold];
    WebPanel2.ParentFont := False;
    WebPanel2.TabOrder := 3;
    WebPanel3.SetParentComponent(WebPanel1);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 0;
    WebPanel3.Top := 334;
    WebPanel3.Width := 640;
    WebPanel3.Height := 48;
    WebPanel3.Align := alBottom;
    WebPanel3.ChildOrder := 11;
    WebPanel3.TabOrder := 4;
    WebButton1.SetParentComponent(WebPanel3);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 13;
    WebButton1.Top := 10;
    WebButton1.Width := 96;
    WebButton1.Height := 25;
    WebButton1.Caption := 'Save';
    WebButton1.HeightPercent := 100.000000000000000000;
    WebButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton1, Self, 'OnClick', 'WebButton1Click');
    WebButton2.SetParentComponent(WebPanel3);
    WebButton2.Name := 'WebButton2';
    WebButton2.Left := 129;
    WebButton2.Top := 10;
    WebButton2.Width := 96;
    WebButton2.Height := 25;
    WebButton2.Caption := 'Cancel';
    WebButton2.ChildOrder := 1;
    WebButton2.HeightPercent := 100.000000000000000000;
    WebButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton2, Self, 'OnClick', 'WebButton2Click');
    cbxSuspended.SetParentComponent(WebPanel1);
    cbxSuspended.Name := 'cbxSuspended';
    cbxSuspended.Left := 232;
    cbxSuspended.Top := 192;
    cbxSuspended.Width := 113;
    cbxSuspended.Height := 22;
    cbxSuspended.Caption := 'cbxSuspended';
    cbxSuspended.ChildOrder := 10;
    cbxSuspended.HeightPercent := 100.000000000000000000;
    cbxSuspended.WidthPercent := 100.000000000000000000;
    cbxBankAccounts.SetParentComponent(WebPanel1);
    cbxBankAccounts.Name := 'cbxBankAccounts';
    cbxBankAccounts.Left := 232;
    cbxBankAccounts.Top := 220;
    cbxBankAccounts.Width := 113;
    cbxBankAccounts.Height := 22;
    cbxBankAccounts.Caption := 'cbxBankAccounts';
    cbxBankAccounts.ChildOrder := 11;
    cbxBankAccounts.HeightPercent := 100.000000000000000000;
    cbxBankAccounts.WidthPercent := 100.000000000000000000;
    cbxCardPayment.SetParentComponent(WebPanel1);
    cbxCardPayment.Name := 'cbxCardPayment';
    cbxCardPayment.Left := 232;
    cbxCardPayment.Top := 248;
    cbxCardPayment.Width := 113;
    cbxCardPayment.Height := 22;
    cbxCardPayment.Caption := 'cbxCardPayment';
    cbxCardPayment.ChildOrder := 12;
    cbxCardPayment.HeightPercent := 100.000000000000000000;
    cbxCardPayment.WidthPercent := 100.000000000000000000;
    wcGLCodes.SetParentComponent(Self);
    wcGLCodes.Name := 'wcGLCodes';
    wcGLCodes.Connection := dmData.dbConnect;
    wcGLCodes.Left := 32;
    wcGLCodes.Top := 56;
    wdsGLCodes.SetParentComponent(Self);
    wdsGLCodes.Name := 'wdsGLCodes';
    wdsGLCodes.AfterOpen := wdsGLCodesAfterOpen;
    wdsGLCodes.Connection := dmData.dbConnect;
    wdsGLCodes.Left := 88;
    wdsGLCodes.Top := 56;
    wdsGLCodesGLCODE.SetParentComponent(wdsGLCodes);
    wdsGLCodesGLCODE.Name := 'wdsGLCodesGLCODE';
    wdsGLCodesGLCODE.FieldName := 'GLCODE';
    wdsGLCodesGLDESCRIPTION.SetParentComponent(wdsGLCodes);
    wdsGLCodesGLDESCRIPTION.Name := 'wdsGLCodesGLDESCRIPTION';
    wdsGLCodesGLDESCRIPTION.FieldName := 'GLDESCRIPTION';
    wdsGLCodesSUSPENDED.SetParentComponent(wdsGLCodes);
    wdsGLCodesSUSPENDED.Name := 'wdsGLCodesSUSPENDED';
    wdsGLCodesSUSPENDED.FieldName := 'SUSPENDED';
    wdsGLCodesbankaccount.SetParentComponent(wdsGLCodes);
    wdsGLCodesbankaccount.Name := 'wdsGLCodesbankaccount';
    wdsGLCodesbankaccount.FieldName := 'bankaccount';
    wdsGLCodesbankcard.SetParentComponent(wdsGLCodes);
    wdsGLCodesbankcard.Name := 'wdsGLCodesbankcard';
    wdsGLCodesbankcard.FieldName := 'bankcard';
    dsGLCodes.SetParentComponent(Self);
    dsGLCodes.Name := 'dsGLCodes';
    dsGLCodes.DataSet := wdsGLCodes;
    dsGLCodes.Left := 144;
    dsGLCodes.Top := 56;
  finally
    WebPanel1.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebDBEdit1.AfterLoadDFMValues;
    WebDBEdit2.AfterLoadDFMValues;
    WebButton3.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
    WebButton2.AfterLoadDFMValues;
    cbxSuspended.AfterLoadDFMValues;
    cbxBankAccounts.AfterLoadDFMValues;
    cbxCardPayment.AfterLoadDFMValues;
    wcGLCodes.AfterLoadDFMValues;
    wdsGLCodes.AfterLoadDFMValues;
    wdsGLCodesGLCODE.AfterLoadDFMValues;
    wdsGLCodesGLDESCRIPTION.AfterLoadDFMValues;
    wdsGLCodesSUSPENDED.AfterLoadDFMValues;
    wdsGLCodesbankaccount.AfterLoadDFMValues;
    wdsGLCodesbankcard.AfterLoadDFMValues;
    dsGLCodes.AfterLoadDFMValues;
  end;
end;

end.